import type { WebLinkConfig } from './const';

export const cleanFormDataByTypeLink = (web_link_generator: WebLinkConfig) => {
  const typeLink = web_link_generator?.typeLink;

  if (typeLink === 'page') {
    const { agentImage, agentName, ...rest } = web_link_generator;

    return rest;
  }

  return web_link_generator;
};
